import { Grid, Typography } from "@mui/material";

import Dropzone from "../../../components/custom/Dropzone";
import PrimaryButton from "../../../components/custom/PrimaryButton";
import { styled } from "@mui/system";
import { useMutation } from "react-query";
import Dialog from "../../../components/custom/Dialog";
import { useState } from "react";
import { uploadBulkBooks } from "../../../services/booksServices";
import ExampleDoc from "../../../assets/files/upload_books_template.xls";
import { useNavigate } from "react-router-dom";

const StyledContainer = styled(Grid)`
  width: 100%;
  height: 100%;
`;

const BulkUpload = () => {
  const navigate = useNavigate();
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [message, setMessage] = useState("");
  const [file, setFile] = useState(null);
  const { mutate } = useMutation(uploadBulkBooks, {
    onSettled: (data, error, variables, context) => {
      if (error) {
        setMessage(error?.response?.data?.error || error?.response?.data);
      } else {
        setMessage(data?.data);
      }
    },
  });

  return (
    <>
      <StyledContainer sx={{ p: { xs: 2, md: 10 } }}>
        <Typography component="h4" variant="h4" align="left" gutterBottom>
          Bulk upload steps
        </Typography>
        <Typography>
          {"1. Download the template file"}{" "}
          <a href={ExampleDoc} download="upload_books_template.xls">
            here
          </a>
        </Typography>
        <Typography>
          {
            "2. Fill all mandatory fields. Ensure you have typed the full book file name and cover page e.g. TestBook.pdf, TestCover.png"
          }
        </Typography>
        <Typography>
          {
            "3. Create zip file containing the template, your book files and cover pages"
          }
        </Typography>
        <Typography>{"4. Upload zip file"}</Typography>
        <Typography>
          {"5. Keep the process batch id for future reference"}
        </Typography>
        {/* <Typography>{"You can download template file here"}</Typography>
        <PrimaryButton sx={{ mt: 2 }}>
          <a href={ExampleDoc} download="upload_books_template.xls">
            Dowload
          </a>
        </PrimaryButton> */}

        <Dropzone
          filesLimit={1}
          acceptedFiles={[".zip,.rar,.7zip"]}
          onChange={(files) => setFile(files)}
        />

        <Grid container justifyContent="left">
          <PrimaryButton
            onClick={() => {
              setMessage("Uploading batch books file... please wait...");
              setIsDialogOpen(true);

              mutate({ file: file });
            }}
            sx={{ my: { xs: 5, md: 10 }, mr: { xs: 1, md: 8 } }}
          >
            Upload bulk books
          </PrimaryButton>
          <PrimaryButton
            onClick={() => navigate("/books")}
            sx={{ my: { xs: 5, md: 10 } }}
          >
            Cancel
          </PrimaryButton>
        </Grid>
      </StyledContainer>
      <Dialog
        showButton={false}
        action={() => setIsDialogOpen(false)}
        onClose={() => setIsDialogOpen(false)}
        open={isDialogOpen}
      >
        {message}
      </Dialog>
    </>
  );
};

export default BulkUpload;
